/* Village Fabrics: Pairs well with, with one button to add the item and the ticked extras together. 7 October 2026. Markup in snippets/vf-pairs.liquid. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function money(p) { return '£' + (p / 100).toFixed(2); }
  function init(box) {
    if (box.getAttribute('data-vf-ready')) return;
    box.setAttribute('data-vf-ready', '1');
    var section = box.closest('section') || box.closest('.shopify-section') || document;
    var mainPrice = parseInt(box.getAttribute('data-main-price'), 10) || 0;
    var btn = box.querySelector('[data-vf-add]');
    var msg = box.querySelector('[data-vf-msg]');
    if (!btn) return;
    function mainForm() { return section.querySelector('product-form form') || document.querySelector('product-form form'); }
    function qty() { var q = section.querySelector('.product-form__quantity .quantity__input') || section.querySelector('.quantity__input'); var n = q ? parseInt(q.value, 10) : 1; return n > 0 ? n : 1; }
    function rows() { return Array.prototype.slice.call(box.querySelectorAll('.vf-pairs__item')); }
    function variantOf(row) {
      var el = row.querySelector('.vf-pairs__variant');
      if (!el) return null;
      if (el.tagName === 'SELECT') { var o = el.options[el.selectedIndex]; return o ? { id: o.value, price: parseInt(o.getAttribute('data-price'), 10) || 0 } : null; }
      return { id: el.value, price: parseInt(el.getAttribute('data-price'), 10) || 0 };
    }
    function update() {
      var total = mainPrice * qty(), n = 0;
      rows().forEach(function (r) {
        var v = variantOf(r), p = r.querySelector('[data-vf-price]');
        if (v && p) p.textContent = money(v.price);
        if (v && r.querySelector('.vf-pairs__check').checked) { total += v.price; n++; }
      });
      box.querySelector('[data-vf-summary]').textContent = n ? 'This item and ' + n + (n === 1 ? ' extra' : ' extras') : 'This item only';
      box.querySelector('[data-vf-total]').textContent = money(total);
      btn.textContent = n ? 'Add all ' + (n + 1) + ' to basket' : 'Add to basket';
    }
    box.addEventListener('change', update);
    section.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('.quantity')) update(); });
    section.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.quantity__button')) setTimeout(update, 0); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) { var v = ev && ev.data && ev.data.variant; if (v && typeof v.price === 'number') { mainPrice = v.price; update(); } });
    }
    btn.addEventListener('click', function () {
      var f = mainForm();
      var idEl = f && f.querySelector('[name="id"]');
      if (!idEl || !idEl.value || idEl.disabled) { msg.textContent = 'Please choose an option above first.'; return; }
      var items = [{ id: parseInt(idEl.value, 10), quantity: qty() }];
      rows().forEach(function (r) { if (r.querySelector('.vf-pairs__check').checked) { var v = variantOf(r); if (v) items.push({ id: parseInt(v.id, 10), quantity: 1 }); } });
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      btn.disabled = true; btn.classList.add('loading'); msg.textContent = '';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { msg.textContent = res.description || res.message || 'Sorry, something went wrong. Please try again.'; return; }
          if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else { window.location.href = root + 'cart'; }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vf-pairs', cartData: res });
        })
        .catch(function () { msg.textContent = 'Sorry, something went wrong. Please try again.'; })
        .then(function () { btn.disabled = false; btn.classList.remove('loading'); });
    });
    update();
  }
  function run() { document.querySelectorAll('[data-vf-pairs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
